// identify links in text and render them as anchor tags, use link page title as anchor text
export default function renderLinks(text: string) {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  const url = text.match(urlRegex)
  
  if (!url) return text

  url.forEach((link) => { 
    const hostname = getUrlHostname(link)
    text = text.replace(link, `<a href="${link}" target="_blank">${hostname}</a>`)
  })
}

const getUrlHostname = (url: string) => { 
  const hostNameRegex = /^https?:\/\/(www\.)?([^/?#]+)(.*)/i
  const matches = url.match(hostNameRegex)
  return matches && matches[2]
}